import gql from 'graphql-tag'

export const upsertOrders = gql`
  mutation upsertOrders(
    $orders: [UpsertOrderInput]
    $week: Int
    $year: Int
  ) {
    upsertOrders(
      orders: $orders
      week: $week
      year: $year
    ) {
      id
      date
      submitted
      editable
      products {
        id
        name
        slug
        unit
        item_number
        pivot {
          quantity
        }
      }
    }
  }
`
